<template>
    <div>
        <mpl-parcel-locker @input="setPickupPoint"
                           :pickup-point="pickupPoint"
                           :skip-groups="skipGroups"
        ></mpl-parcel-locker>
    </div>
</template>

<script>
export default {
    name: 'PostOffices',

    props: {
        pickupPoint: {
            default: null
        }
    },

    data() {
        return {
            skipGroups: {
                "80_trendmaker": true,
                "70_mediamarkt": true,
                "60_egyenipartnerek": true,
                "50_coop": true,
                "30_csomagautomata":true,
                "20_molkut": true,
                "10_posta": false
            }
        }
    },

    methods: {
        setPickupPoint(data) {
            this.$emit('input', data)
        },
    },
}
</script>
